import type { TypeFormFieldElement } from '../../types/form';

// ----------------------------------------------------------------------------

export type TypeSerializedFieldEntry = { name: string; value: string };

// ----------------------------------------------------------------------------

const IGNORED_FIELD_TYPES = new Set(['button', 'file', 'reset', 'submit']);

// ----------------------------------------------------------------------------

function extractFieldValues(elField: TypeFormFieldElement): TypeSerializedFieldEntry[] {
    if (!elField.name || elField.disabled) {
        return [];
    }

    if (IGNORED_FIELD_TYPES.has(elField.type)) {
        return [];
    }

    if (elField instanceof HTMLSelectElement && elField.multiple) {
        const result: TypeSerializedFieldEntry[] = [];

        for (const elOption of elField.options) {
            if (!elOption.selected) {
                continue;
            }

            result.push({
                name: elField.name,
                value: elOption.value,
            });
        }

        return result;
    }

    if (elField instanceof HTMLInputElement && (elField.type === 'checkbox' || elField.type === 'radio')) {
        if (elField.checked) {
            return [
                {
                    name: elField.name,
                    value: elField.value,
                },
            ];
        }

        return [];
    }

    return [
        {
            name: elField.name,
            value: elField.value,
        },
    ];
}

// ----------------------------------------------------------------------------

export default extractFieldValues;
